import React, { useState, useEffect } from "react";
import Cookies from "js-cookie";
import { adminMainUrl } from "../../../Config.jsx";
import DashIcon from "./DashIcon";
import { todayOperations as fallbackOperations } from "./dashboardData";

/**
 * OperationStatCard – a single mini-stat card inside Today's Operations.
 */
const OperationStatCard = ({ label, value, iconType, iconBg, iconColor }) => (
  <div className="ops-today-mini-card">
    <div className="ops-today-icon-wrap" style={{ background: iconBg }}>
      <DashIcon type={iconType} size={22} color={iconColor} />
    </div>
    <span className="ops-today-mini-label">{label}</span>
    <span className="ops-today-mini-value">{value}</span>
  </div>
);

/**
 * TodaysOperations – 3×2 grid of mini-stat cards.
 */
const TodaysOperations = ({ counts }) => {
  const [data, setData] = useState(null);

  useEffect(() => {
    const fetchTodaysOperationsData = async () => {
      const token = Cookies.get('token');
      const user_id = Cookies.get('flexichain_user_id');
      try {
        const response = await fetch(`${adminMainUrl}/api/operation-dashboard-todays-operation-data`, {
          method: "GET",
          headers: {
            'auth-token': token || '',
            'Authorization': token ? (token.startsWith('Bearer ') ? token : `Bearer ${token}`) : '',
            'user_id': user_id || '',
            'user-id': user_id || '',
            'Content-Type': 'application/json',
          }
        });
        const resData = await response.json();
        if (response.ok && resData?.code === 200) {
          setData(resData.data);
        }
      } catch (err) {
        console.error("Error fetching today's operations data:", err);
      }
    };

    fetchTodaysOperationsData();
  }, []);

  let itemsToDisplay = fallbackOperations;

  if (data && data.length > 0) {
    itemsToDisplay = data;
  } else {
    itemsToDisplay = fallbackOperations.map((op) => {
      if (op.label === "Jobs Closed" && counts?.jobsClosedToday !== undefined) {
        return { ...op, value: counts.jobsClosedToday };
      }
      return op;
    });
  }

  return (
    <div className="ops-card ops-today-card">
      <div className="ops-card-header">
        <div className="ops-card-heading">
          <span className="ops-card-heading-icon ops-heading-today">
            <DashIcon type="briefcase" size={17} color="#fff" />
          </span>
          <span className="ops-card-title">Today's Operations</span>
        </div>
      </div>
      <div className="ops-today-grid">
        {itemsToDisplay.map((op) => (
          <OperationStatCard key={op.id} {...op} />
        ))}
      </div>
    </div>
  );
};

export default TodaysOperations;
